import React from "react";
import "./FooterPage.css";
import emblemOne from "../Media/emblem1.svg";
import emblemTwo from "../Media/emblem2.svg";
import facebookWhite from "../Media/facebookwhite.svg";
import instagramWhite from "../Media/instagramwhite.svg";
import linkedinWhite from "../Media/linkedinwhite.svg";


const Footersec = () => {
  // useEffect(() => {
  //   const script = document.createElement("script");
  //   script.src = "https://app.artibot.ai/loader.js";
  //   script.async = true;
  //   script.type = "text/javascript";

  //   script.onload = () => {
  //     try {
  //       if (window.ArtiBot) {
  //         new window.ArtiBot({ i: "ba1817a7-95ba-4e76-91ce-5bcda1e66045" });
  //       } else {
  //         console.warn("ArtiBot object not found after script load.");
  //       }
  //     } catch (err) {
  //       console.error("Error initializing ArtiBot:", err);
  //     }
  //   };

  //   script.onerror = (e) => {
  //     console.error("Failed to load ArtiBot script:", e);
  //   };

  //   document.head.appendChild(script);

  //   return () => {
  //     document.head.removeChild(script);
  //   };
  // }, []);
  return (
    <section className="footersec">
      <div className="top-footer">
        <div className="top-footer-heading">
        <h2 className="building-on-trust">Building On Trust</h2>
        </div>
      </div>
      <div className="mid-footer">
        <div className="company-section">
          <div className="company-heading">
            <h3 className="company-heading-text">Company</h3>
          </div>
          <div className="company-sub-heading">
            <ul className="list-u">
              <li>
                <a className="list-o" href="/whoWeAre">
                  Who We Are
                </a>
              </li>
              <li>
                <a className="list-o" href="/blog">
                  Blog
                </a>
              </li>
              <li>
                <a className="list-o" href="/contactus">
                  Support
                </a>
              </li>
              <li>
                <a className="list-o" href="/privacypolicy">
                Privacy Policy
            </a>
              </li>
              <li>
                <a className="list-o" href="/termsandconditions">
                Terms & Condition
            </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="provider-section">
          <div className="provider-heading">
          <h3 className="provider-heading-text">Services</h3>
          </div>
          <div className="provider-sub-heading">
            <ul className="list-u">
              <li>
                <a className="list-o" href="/contactus">
                  Software Development
                </a>
              </li>
              <li>
                <a className="list-o" href="/contactus">
                  Mobile App Development
                </a>
              </li>
              <li>
                <a className="list-o" href="/contactus">
                  Product & Customer Support
                </a>
              </li>
              <li>
                <a className="list-o" href="/contactus">
                  Web Design & Development
                </a>
              </li>
              <li>
                <a className="list-o" href="/contactus">
                  AI & Data Science
                </a>
              </li>
              <li>
                <a className="list-o" href="/contactus">
                  Digital Marketing
                </a>
              </li>
              <li>
                <a className="list-o" href="/contactus">
                  Resource to Hire
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="connect-section">
          <div className="connect-heading">
          <h3 className="connect-heading-text">Connect</h3>
          </div>
          <div className="connect-sub-heading">
            <ul className="list-u">
              <li>
                <a href="tel:+91 04652 236 359" className="list-o">
                  Telephone (India):&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  : &nbsp;&nbsp;+91 04652 236 359
                </a>
              </li>
              <li>
                <a href="tel:+917603908036" className="list-o">
                  Mobile&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  : &nbsp;&nbsp;+91 7603 908 036
                </a>
              </li>
              <li>
                <a href="mailto:info@althisolutions.com" className="list-o">
                  General Information&nbsp;&nbsp;&nbsp;&nbsp; :
                  &nbsp;&nbsp;info@althisolutions.com
                </a>
              </li>
              <li>
                <a href="mailto:sales@althisolutions.com" className="list-o">
                  Sales
                  Inquiry&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  : &nbsp;&nbsp;sales@althisolutions.com
                </a>
              </li>
              <li>
                <a href="mailto:hr@althisolutions.com" className="list-o">
                  HR
                  Inquiry&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  : &nbsp;&nbsp;hr@althisolutions.com
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    <div className="bot-footer">
      <div className="white-socialmedia">
        <div className="white-facebook">
          <a className="list-o" href="https://www.facebook.com/profile.php?id=61561245098973" target="_blank" rel="noreferrer">
            <img className="white-facebook-icon" src={facebookWhite} alt="facebook" />
          </a>
        </div>
        <div className="white-linkedin">
          <a className="list-o" href="https://in.linkedin.com/company/althisolutions" target="_blank" rel="noreferrer">
            <img className="white-linkedin-icon" src={linkedinWhite} alt="linkedin" />
          </a>
        </div>
        <div className="white-instagram">
          <a className="list-o" href="https://www.instagram.com/althi_solutions" target="_blank" rel="noreferrer">
            <img className="white-instagram-icon" src={instagramWhite} alt="instagram" />
          </a>
        </div>
      </div>

      <div className="right-reserved">
        <p className="right-reserved-text">
          Althi Solutions &copy; {new Date().getFullYear()} All Rights Reserved
        </p>
      </div>

      <div className="certification-badges-wrapper">
        <div className="emblem-one">
          <img src={emblemOne} alt="ISO Certified Badge" />
        </div>
        <div className="emblem-two">
          <img src={emblemTwo} alt="DPIIT Recognized Badge" />
        </div>
      </div>
    </div>
    </section>
  );
};

export default Footersec;
